import isArray from 'lodash/isArray';
import { getArrayRem } from './getArrayRem';
import { getRem } from './getRem';
export function getValue(value, unit) {
  if (unit === 'rem') {
    if (isArray(value)) {
      return getArrayRem(value);
    }
    return getRem(value);
  }
  return value;
}
//# sourceMappingURL=getValue.js.map